<template>
  <div id="feedback">
    <h2 class="feedback-title">
      Bist Du zufrieden mit der Preisbewertung?
    </h2>
    <transition name="fade" mode="out-in">
      <div v-if="!feedbackType" key="start">
        <p class="feedback-description">
          Ist die Preisbewertung Deines Fahrzeugs Deiner Meinung nach <br />
          zufriedenstellend? Gib hier Dein unverbindliches Feedback!
        </p>

        <div class="feedback-buttons">
          <div class="feedback-btn btn-yes" @click="updateFeedback('yes')">
            <img src="~@/assets/yes-car.png" alt="Ja" />
            <span>Ja</span>
          </div>
          <div class="feedback-btn btn-no" @click="updateFeedback('no')">
            <img src="~@/assets/no-car.png" alt="Nein" />
            <span>Nein</span>
          </div>
        </div>
      </div>

      <div v-else-if="feedbackType == 'no'" key="no">
        <div class="feedback-aswer">
          <img
            src="~@/assets/no-car.png"
            alt="Nein"
            class="feedback-answer_image"
          />
          <p class="feedback-answer_description">
            Vielen Dank! Welchen Preis hast Du erwartet?
          </p>
          <div class="feedback-answer_form">
            <input
              v-model="milage"
              type="number"
              class="feedback-answer_form-input"
              min="0"
            />
            <div
              class="feedback-answer_form-button"
              @click="updateFeedback('success')"
              v-wave="{
                color: '#c4232a',
                initialOpacity: 0.5,
                easing: 'ease-in'
              }"
            >
              senden
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="feedbackType == 'success'" key="success">
        <div class="feedback-aswer">
          <img
            src="~@/assets/thanks-car.png"
            alt="Nein"
            class="feedback-answer_image"
          />
          <p class="feedback-answer_description">
            Danke für Dein Feedback. Durch Deine Eingabe hilfst du uns unseren
            Service stetig zu verbessern.
          </p>
        </div>
      </div>

      <div v-else-if="feedbackType == 'yes'" key="yes">
        <div class="feedback-aswer">
          <img
            src="~@/assets/yes-car.png"
            alt="Nein"
            class="feedback-answer_image"
          />
          <p class="feedback-answer_description">
            Vielen Dank für Deine Antwort! Wir freuen uns, dass Du mit der
            Preisbewertung zufrieden bist!.
          </p>
          <div class="feedback-answer_button" @click="sendToForm">
            Jetzt Fahrzeug verkaufen
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import { Api } from "../../services/api";

export default {
  props: ["name", "lead"],
  components: { FadeTransition },
  data: () => ({
    feedbackType: "",
    milage: null,
    loading: false
  }),
  methods: {
    async updateFeedback(val) {
      let cloned = {};
      Object.assign(cloned, this.lead);
      if (val == "no") {
        cloned.evaluation_feedback.feedback = "negative";
        cloned.evaluation_feedback.expected_price = null;
      }
      if (val == "yes") {
        cloned.evaluation_feedback.feedback = "positive";
        cloned.evaluation_feedback.expected_price = null;
      }
      if (val == "success") {
        cloned.evaluation_feedback.feedback = "negative";
        cloned.evaluation_feedback.expected_price = this.milage;
      }
      this.$store.commit("updateLead", { lead: cloned });
      try {
        this.loading = true;
        await Api.put(this.$store, "updateFeedback");
        this.feedbackType = val;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    send() {
      this.feedbackType = "success";
    },
    sendToForm() {
      window.location.href = `/auto-verkaufen/verkauf-1/${this.lead.token}`;
    }
  }
};
</script>

<style lang="scss">
#feedback {
  padding: 40px 110px;
  background: #f6f7fb;
  margin-bottom: 30px;
  border-radius: 20px;
  @media (max-width: 900px) {
    border-radius: 0;
    padding: 40px 20px;
  }
}

.feedback-title {
  color: #010101;
  font-family: "Asap", sans-serif;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 5px;
}

.feedback-description {
  font-size: 18px;
  margin-bottom: 50px;

  &.gray {
    color: #737373;
    line-height: 1.6;
  }
}
.feedback-buttons {
  display: flex;
  justify-content: center;
  .feedback-btn {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    height: 150px;
    border-radius: 20px;
    margin: 15px;
    cursor: pointer;
    transition: 0.33s;
    // border: 3px solid #ffffff;
    position: relative;
    overflow: hidden;
    user-select: none;
    img {
      margin-top: 30px;
      margin-bottom: 10px;
      transition: 0.5s;
      z-index: 3;
    }
    span {
      font-family: "Asap", sans-serif;
      font-size: 28px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 50px;
      text-align: center;
      z-index: 3;
    }
    &:hover {
      img {
        transform: rotateY(180deg);
      }
    }
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 100%;

      transition: 0.5s;
      z-index: 2;
    }
    &.btn-yes:before {
      background: lighten(#5b9069, 40%);
    }
    &.btn-no:before {
      background: lighten(#c4232a, 40%);
    }
    &:hover::before {
      top: 0;
    }
  }
}
.feedback-aswer {
  background: #ffffff;
  padding: 30px 100px;
  border-radius: 20px;
  position: relative;
  margin-top: 90px;
  margin-bottom: 40px;
  @media (max-width: 900px) {
    padding: 30px 10px;
  }
  .feedback-answer_image {
    position: absolute;
    top: -50px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .feedback-answer_description {
    font-size: 18px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: 30px;
    text-align: center;
  }
  .feedback-answer_button {
    display: inline-block;
    line-height: 48px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    height: 50px;
    border-radius: 25px;
    font-family: "Asap", sans-serif;
    background-color: #c4232a;
    padding: 0 40px;
    &:hover {
      background-color: rgba(196, 35, 42, 0.9);
    }
  }
  .feedback-answer_form {
    position: relative;
    .feedback-answer_form-input {
      height: 50px;
      border-radius: 25px;
      background-color: #f7f7f7;
      border: none;
      padding: 20px 30px;
      width: 100%;
    }
    .feedback-answer_form-button {
      user-select: none;
      width: 120px;
      height: 100%;
      border-radius: 25px;
      color: #ffffff;
      background-color: #c4232a;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      &:hover {
        background-color: rgba(196, 35, 42, 0.9);
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/SummaryFeedback.vue